import logo_corporacion from '../../assets/img/corporacion.jpg'
import logo_manvar from '../../assets/img/manvar.png'
// import signature from '../../assets/img/firma.png'
import signature from '../../assets/img/firma-manolo.jpeg'

export const addHeader = (doc) => {
  // doc.addImage(logo_corporacion, 'PNG', 120, 10, 80, 30);
  doc.addImage(logo_manvar, 'PNG', 20, 10, 40, 30);
};

export const addFooter = (doc) => {
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text('KM 59.5 CARRETERA A TAXISCO, COLONIA PALO BLANCO, ESCUINTLA, ESCUINTLA', 105, 280, null, null, 'center');
  doc.text('PBX: 2458-1568 EXT 2', 105, 285, null, null, 'center');
};

export const addSignature = (doc, y) => {
  doc.addImage(signature, 'PNG', 75, y, 70, 35);
  doc.line(80, y+25, 140, y+25);
  doc.text('Lic. Manolo Vargas', 110, y+30, null, null, 'center');
  doc.text('Gerente General', 110, y+35, null, null, 'center');

  // doc.line(80, y+35, 140, y+35);
  // doc.text('Lic. Manolo Vargas', 110, y+40, null, null, 'center');
  // doc.text('Gerente General', 110, y+45, null, null, 'center');
};

export const addTitle = (doc, y, text) => {

  doc.setFont("helvetica", "normal");
  doc.setFontSize(18);

  const pageWidth = doc.internal.pageSize.width; // Ancho de la página
  const textWidth = doc.getTextWidth(text); // Ancho del texto
  const x = (pageWidth - textWidth) / 2;

  doc.text(text, x, y);

};

// export const justifyText = (doc, text, x, y, maxWidth) => {
//   // Dividir texto en líneas según saltos de línea
//   const paragraphs = text.split('\n'); // Cada párrafo es una línea separada por \n
//   let currentY = y; // Mantiene la posición vertical en el documento

//   paragraphs.forEach((paragraph) => {
//     // Dividir párrafo en bloques (bold o normales)
//     const blocks = [];
//     const regex = /\*\*(.*?)\*\*|(\S+)/g; // Detecta texto entre ** o palabras normales
//     let match;

//     while ((match = regex.exec(paragraph)) !== null) {
//       if (match[1]) {
//         // Si es un bloque bold, dividirlo en palabras y marcarlas como bold
//         const boldWords = match[1].split(' ').map((word) => ({
//           text: word,
//           bold: true,
//         }));
//         blocks.push(...boldWords);
//       } else if (match[2]) {
//         // Palabra normal
//         blocks.push({ text: match[2], bold: false });
//       }
//     }

//     let line = [];
//     let lines = [];
//     let currentWidth = 0;

//     // Construir líneas basadas en el ancho máximo
//     blocks.forEach((block) => {
//       const testWidth = doc.getTextWidth(block.text + ' ')+1; // Incluye espacio
//       if (currentWidth + testWidth > maxWidth) {
//         lines.push(line); // Agregar línea completa
//         line = []; // Iniciar nueva línea
//         currentWidth = 0;
//       }
//       line.push(block); // Agregar bloque a la línea actual
//       currentWidth += testWidth; // Sumar ancho del bloque
//     });

//     if (line.length) {
//       lines.push(line); // Agregar última línea
//     }

//     // Renderizar texto línea por línea
//     lines.forEach((line) => {
//       let currentX = x;

//       line.forEach((block) => {
//         if (block.bold) {
//           doc.setFont('times', 'bold'); // Estilo bold
//         } else {
//           doc.setFont('times', 'normal'); // Estilo normal
//         }
//         doc.text(block.text, currentX, currentY); // Renderizar texto
//         currentX += doc.getTextWidth(block.text + ' ')+1; // Avanzar posición
//       });

//       currentY += 7; // Avanzar a la siguiente línea verticalmente
//     });

//     currentY += 5; // Espacio adicional entre párrafos
//   });

//   // Devolver la posición final de Y
//   return currentY;
// };

export const justifyText = (doc, text, x, y, maxWidth) => {
  const paragraphs = text.split('\n');
  let currentY = y;

  paragraphs.forEach((paragraph) => {
    // Dividir párrafo en bloques (bold o normales)
    const blocks = [];
    const regex = /\*\*(.*?)\*\*|([^\s*]+)/g;
    let match;

    while ((match = regex.exec(paragraph)) !== null) {
      if (match[1]) {
        // Texto en negrita - dividir en palabras
        const boldWords = match[1].split(' ').filter(w => w.length > 0);
        boldWords.forEach((word) => {
          blocks.push({ text: word, bold: true });
        });
      } else if (match[2]) {
        // Palabra normal
        blocks.push({ text: match[2], bold: false });
      }
    }

    // Construir líneas
    let lines = [];
    let currentLine = [];
    let currentWidth = 0;

    blocks.forEach((block, index) => {
      // Calcular ancho del bloque con su fuente
      doc.setFont('times', block.bold ? 'bold' : 'normal');
      const blockWidth = doc.getTextWidth(block.text);
      const spaceWidth = doc.getTextWidth(' ');

      // Si no es el primer bloque de la línea, sumar el espacio
      const widthWithSpace = currentLine.length > 0 ? blockWidth + spaceWidth : blockWidth;

      if (currentLine.length > 0 && currentWidth + widthWithSpace > maxWidth) {
        // No cabe en esta línea, guardar línea actual y empezar nueva
        lines.push(currentLine);
        currentLine = [block];
        currentWidth = blockWidth;
      } else {
        // Cabe en la línea actual
        currentLine.push(block);
        currentWidth += widthWithSpace;
      }
    });

    // Agregar última línea
    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    // Renderizar líneas con justificación
    lines.forEach((line, lineIndex) => {
      const isLastLine = lineIndex === lines.length - 1;

      if (isLastLine || line.length === 1) {
        // Última línea o línea con una sola palabra: alinear a la izquierda
        let currentX = x;
        line.forEach((block, blockIndex) => {
          doc.setFont('times', block.bold ? 'bold' : 'normal');
          doc.text(block.text, currentX, currentY);
          currentX += doc.getTextWidth(block.text);

          // Agregar espacio entre palabras (excepto después de la última)
          if (blockIndex < line.length - 1) {
            currentX += doc.getTextWidth(' ');
          }
        });
      } else {
        // Justificar: calcular ancho total de palabras
        let totalWordsWidth = 0;
        line.forEach((block) => {
          doc.setFont('times', block.bold ? 'bold' : 'normal');
          totalWordsWidth += doc.getTextWidth(block.text);
        });

        // Calcular espacio disponible y espacio entre palabras
        const availableSpace = maxWidth - totalWordsWidth;
        const gaps = line.length - 1; // Número de espacios entre palabras
        const spaceWidth = gaps > 0 ? availableSpace / gaps : 0;

        // Renderizar con espacios distribuidos
        let currentX = x;
        line.forEach((block, blockIndex) => {
          doc.setFont('times', block.bold ? 'bold' : 'normal');
          doc.text(block.text, currentX, currentY);
          currentX += doc.getTextWidth(block.text);

          // Agregar espacio justificado (excepto después de la última palabra)
          if (blockIndex < line.length - 1) {
            currentX += spaceWidth;
          }
        });
      }

      currentY += 7; // Siguiente línea
    });

    currentY += 5; // Espacio entre párrafos
  });

  return currentY;
};

export const justifyTextBox = (doc, text, x, y, maxWidth, options = {}) => {
  // Valores por default
  const {
    fontSize = 10,
    fontName = 'times',
    lineSpacing = 5
  } = options;

  doc.setFontSize(fontSize);

  // Dividir texto en líneas según saltos de línea
  const paragraphs = text.split('\n');
  let currentY = y;

  paragraphs.forEach((paragraph) => {
    // Dividir párrafo en bloques (bold o normales)
    const blocks = [];
    const regex = /\*(.*?)\*|([^\s*]+)/g; // Detecta texto entre * o palabras normales
    let match;

    while ((match = regex.exec(paragraph)) !== null) {
      if (match[1]) {
        // Texto en negrita - dividir en palabras
        const boldWords = match[1].split(' ').filter(w => w.length > 0);
        boldWords.forEach((word) => {
          blocks.push({ text: word, bold: true });
        });
      } else if (match[2]) {
        // Palabra normal
        blocks.push({ text: match[2], bold: false });
      }
    }

    // Si el párrafo está vacío, solo agregar espacio
    if (blocks.length === 0) {
      currentY += lineSpacing;
      return;
    }

    // Construir líneas
    let lines = [];
    let currentLine = [];
    let currentWidth = 0;

    blocks.forEach((block) => {
      // Calcular ancho del bloque con su fuente
      doc.setFont(fontName, block.bold ? 'bold' : 'normal');
      const blockWidth = doc.getTextWidth(block.text);
      const spaceWidth = doc.getTextWidth(' ');

      // Si no es el primer bloque de la línea, sumar el espacio
      const widthWithSpace = currentLine.length > 0 ? blockWidth + spaceWidth : blockWidth;

      if (currentLine.length > 0 && currentWidth + widthWithSpace > maxWidth) {
        // No cabe en esta línea, guardar línea actual y empezar nueva
        lines.push(currentLine);
        currentLine = [block];
        currentWidth = blockWidth;
      } else {
        // Cabe en la línea actual
        currentLine.push(block);
        currentWidth += widthWithSpace;
      }
    });

    // Agregar última línea
    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    // Renderizar líneas con justificación
    lines.forEach((line, lineIndex) => {
      const isLastLine = lineIndex === lines.length - 1;

      if (isLastLine || line.length === 1) {
        // Última línea o línea con una sola palabra: alinear a la izquierda
        let currentX = x;
        line.forEach((block, blockIndex) => {
          doc.setFont(fontName, block.bold ? 'bold' : 'normal');
          doc.text(block.text, currentX, currentY);
          currentX += doc.getTextWidth(block.text);

          // Agregar espacio entre palabras (excepto después de la última)
          if (blockIndex < line.length - 1) {
            currentX += doc.getTextWidth(' ');
          }
        });
      } else {
        // Justificar: calcular ancho total de palabras
        let totalWordsWidth = 0;
        line.forEach((block) => {
          doc.setFont(fontName, block.bold ? 'bold' : 'normal');
          totalWordsWidth += doc.getTextWidth(block.text);
        });

        // Calcular espacio disponible y espacio entre palabras
        const availableSpace = maxWidth - totalWordsWidth;
        const gaps = line.length - 1; // Número de espacios entre palabras
        const spaceWidth = gaps > 0 ? availableSpace / gaps : 0;

        // Renderizar con espacios distribuidos
        let currentX = x;
        line.forEach((block, blockIndex) => {
          doc.setFont(fontName, block.bold ? 'bold' : 'normal');
          doc.text(block.text, currentX, currentY);
          currentX += doc.getTextWidth(block.text);

          // Agregar espacio justificado (excepto después de la última palabra)
          if (blockIndex < line.length - 1) {
            currentX += spaceWidth;
          }
        });
      }

      currentY += lineSpacing; // Siguiente línea
    });

    // currentY += lineSpacing; // Espacio adicional entre párrafos
  });

  // Devolver la posición final de Y
  return currentY;
};

// export const justifyTextBox = (doc, text, x, y, maxWidth, options = {}) => {
//   // Valores por default
//   const {
//     fontSize = 10,
//     fontName = 'times',
//     lineSpacing = 5
//   } = options

//   // console.log('justifyTextBox ----- ', {doc, text, x, y, maxWidth, options})

//   doc.setFontSize(fontSize);

//   // Dividir texto en líneas según saltos de línea
//   const paragraphs = text.split('\n'); // Cada párrafo es una línea separada por \n
//   let currentY = y; // Mantiene la posición vertical en el documento

//   paragraphs.forEach((paragraph) => {
//     // Dividir párrafo en bloques (bold o normales)
//     const blocks = [];
//     const regex = /\*(.*?)\*|(\S+)/g; // Detecta texto entre ** o palabras normales
//     let match;

//     while ((match = regex.exec(paragraph)) !== null) {
//       if (match[1]) {
//         // Si es un bloque bold, dividirlo en palabras y marcarlas como bold
//         const boldWords = match[1].split(' ').map((word) => ({
//           text: word,
//           bold: true,
//         }));
//         blocks.push(...boldWords);
//       } else if (match[2]) {
//         // Palabra normal
//         blocks.push({ text: match[2], bold: false });
//       }
//     }

//     let line = [];
//     let lines = [];
//     let currentWidth = 0;

//     // Construir líneas basadas en el ancho máximo
//     blocks.forEach((block) => {
//       const testWidth = doc.getTextWidth(block.text + ' ') + 1; // Incluye espacio
//       if (currentWidth + testWidth > maxWidth) {
//         lines.push(line); // Agregar línea completa
//         line = []; // Iniciar nueva línea
//         currentWidth = 0;
//       }
//       line.push(block); // Agregar bloque a la línea actual
//       currentWidth += testWidth; // Sumar ancho del bloque
//     });

//     if (line.length) {
//       lines.push(line); // Agregar última línea
//     }

//     // Renderizar texto línea por línea
//     lines.forEach((line) => {
//       let currentX = x;

//       line.forEach((block) => {
//         if (block.bold) {
//           doc.setFont(fontName, 'bold'); // Estilo bold
//         } else {
//           doc.setFont(fontName, 'normal'); // Estilo normal
//         }
//         doc.text(block.text, currentX, currentY); // Renderizar texto
//         currentX += doc.getTextWidth(block.text + ' ') + 1; // Avanzar posición
//       });

//       currentY += lineSpacing; // Avanzar a la siguiente línea verticalmente
//     });

//     currentY += lineSpacing; // Espacio adicional entre párrafos
//   });

//   // Devolver la posición final de Y
//   return currentY;
// };